import { Outlet } from 'react-router-dom';
import { scriptsConfig } from '../../config/scriptsConfig';
import { FetchingDataGate } from '../../gates/FetchingDataGate';
import { LanguageSelectionGate } from '../../gates/LanguageSelectionGate';
import { useCustomScript } from '../../hooks/useCustomScript';

export const AppLayout = () => {
    useCustomScript({ url: scriptsConfig.getTidioUrl('uf3regnbzb61z8gj4e8gethqdpv8le40') });
    return (
        <FetchingDataGate>
            <LanguageSelectionGate>
                <Outlet />
            </LanguageSelectionGate>
        </FetchingDataGate>
    );
};
